/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Task owner.
 *
 * Defines who can action a task, and which apps can see the task in their task list.
 */
export enum TaskOwner {
  CONTRACTOR = 'contractor',
  SEALED_OPS = 'sealed_ops',
}
